import { Dic } from '$utils'
const tableOption = function (that) {
  return {
    page: false,
    selection: false,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    addFormSlot: true,
    viewFormSlot: true,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '资产类型',
        prop: 'fireassetType',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 24,
        align: 'center',
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU077', value) : '';
        }
      },
      {
        label: '归还资产名称',
        prop: 'fireassetName',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true
      },
      {
        label: '归还数量',
        prop: 'returnNumber',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12
      },
      {
        label: '归还人',
        type: 'select',
        prop: 'returnName',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        dicData: [],
        span: 12
      },
      {
        label: '归还时间',
        prop: 'returnTime',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12
      },
      {
        label: '接收人',
        type: 'select',
        prop: 'recieveName',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        dicData: [],
        span: 12
      },
      {
        label: '备注',
        prop: 'desc',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 12
      }
    ]
  }
}
export default tableOption